export const ensureFieldRegisteredAndSet =
  (register, setValue, clearErrors) => (name: string, value: any) => {
    setTimeout(() => {
      try {
        register(name, { required: 'This field is required.' });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
      }

      setValue(name, value, { shouldValidate: true });
      clearErrors(name);
    }, 0);
  };

export const findDependentQuestions = (questions, questionIdToDelete) =>
  questions.filter(
    (question) =>
      question.id !== questionIdToDelete &&
      question.options?.some((option) => option.target?.id === questionIdToDelete),
  );
